<template>
  <div
    v-if="iconImg"
    class="icon-site"
  >
    <img
      v-if="isLazy"
      v-lazy="getSrc(iconImg)"
      class="icon-site-img"
      onerror="this.style.display='none'"
    >
    <img
      v-else
      class="icon-site-img"
      :src="getSrc(iconImg)"
      onerror="this.style.display='none'"
    >
    <i
      v-if="iconType"
      class="icon-site-type"
      :class="'icon-' + iconType"
    />
  </div>
</template>

<script>
import { LOGO_CDN_PATH } from '../../common/js/util';

export default {
  props: {
    iconImg: {
      type: String,
      default: '',
    },
    iconType: {
      type: String,
      default: '',
    },
    isLazy: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getSrc() {
      const { iconImg } = this;
      return (
        (/[a-zA-Z0-9_-]+\.(?:png|jpg)$/g.test(iconImg) && !/^(https?:)?\/\//.test(iconImg) ? LOGO_CDN_PATH : '')
        + iconImg
      );
    },
  },
};
</script>

<style lang="scss">
.icon-site {
  position: relative;
  display: inline-block;
  width: 14px;
  min-width: 14px;
  height: 14px;
  margin-right: 4px;
  border: 1px solid rgba(0, 0, 0, 0.02);
  border-radius: 50%;
  vertical-align: middle;
  margin-top: -1px;
  &-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 14px;
    height: 14px;
    border-radius: 50%;
  }
  &-type {
    position: absolute;
    right: -2px;
    bottom: -2px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
}
</style>
